module.exports = __webpack_public_path__ + "static/media/filter-solid.4c888616.svg";